import moment from 'moment';

const WebpageColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 90,
    sorter: (a, b) => a.index - b.index
  },
  {
    title: 'Webpage Name',
    dataIndex: 'config_name',
    width: 200,
    sorter: (a, b) => (a.config_name || '').localeCompare(b.config_name || '')
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url_name',
    width: 180,
    slot: 'urls'
  },
  {
    title: 'Tags',
    dataIndex: 'tags',
    width: 200,
    slot: 'tags',
    sorter: (a, b) => {
      const aTags = Array.isArray(a.tags) ? a.tags.join(',') : '';
      const bTags = Array.isArray(b.tags) ? b.tags.join(',') : '';
      return aTags.localeCompare(bTags);
    }
  },
  {
    title: 'Plan Type',
    dataIndex: 'plan_type',
    width: 130,
    slot: 'plan_type',
    sorter: (a, b) => (a.plan_type || '').localeCompare(b.plan_type || '')
  },
  {
    title: 'Polling Interval',
    dataIndex: 'polling_interval',
    width: 150,
    slot: 'polling_interval',
    sorter: (a, b) => (a.polling_interval || 0) - (b.polling_interval || 0)
  },
  {
    title: 'Last Verified',
    dataIndex: 'last_verify',
    width: 150,
    slot: 'last_verify',
    sorter: (a, b) => moment(a.last_verify).diff(moment(b.last_verify)),
  },
  {
    title: 'Status',
    dataIndex: 'health_status',
    width: 200,
    slot: 'status',
    sorter: (a, b) => (a.health_status || '').localeCompare(b.health_status || '')
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];
const AnalyticsColumns = [
  {
    dataIndex: 'enable',
    key: 'enable',
    slots: { title: 'customTitle' },
    scopedSlots: { customRender: 'enable' },
    width: 50
  },
  {
    title: 'No.',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 50
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' },
    width: 250
  },
  {
    title: 'Last Verified Value',
    dataIndex: 'lastVerifiedValue',
    key: 'lastVerifiedValue',
    scopedSlots: { customRender: 'lastVerifiedValue' },
    width: 150
  },
  {
    title: 'Baseline Value',
    dataIndex: 'baselineValue',
    key: 'baselineValue',
    scopedSlots: { customRender: 'baselineValue' },
    width: 150
  },
  {
    title: 'Threshold',
    dataIndex: 'threshold',
    key: 'threshold',
    width: 100,
    scopedSlots: { customRender: 'threshold' }
  },
  {
    title: 'Detail',
    dataIndex: 'detail',
    key: 'detail',
    width: 100,
    scopedSlots: { customRender: 'detail' }
  }
];
const BaselineResultColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 100,
    key: 'index',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: 'Recommended Value',
    dataIndex: 'recommendedValue',
    key: 'recommendedValue',
    width: 200,
    scopedSlots: { customRender: 'recommendedValue' }
  },
  {
    title: 'Threshold',
    dataIndex: 'threshold',
    key: 'threshold',
    width: 200,
    scopedSlots: { customRender: 'threshold' }
  },
  {
    title: 'Detail',
    dataIndex: 'detail',
    key: 'detail',
    width: 200,
    scopedSlots: { customRender: 'detail' }
  }
];

const ContactGroupColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 90,
    key: 'index',
    slot: 'index'
  },
  {
    title: 'Contact Group',
    dataIndex: 'contact_group',
    key: 'contact_group',
    width: 150,
    slot: 'contact_group'
  },
  {
    title: 'Contacts',
    dataIndex: 'contacts',
    key: 'contacts',
    width: 250,
    maxHeight: 200,
    slot: 'contacts',
  },
  {
    title: 'Email',
    dataIndex: 'contacts',
    key: 'email',
    width: 250,
    maxHeight: 200,
    slot: 'email',
  },
  {
    title: 'Actions',
    width: 150,
    slot: 'contact_group_id',
    key: 'contact_group_id',
  }
];

export { WebpageColumns, AnalyticsColumns, BaselineResultColumns, ContactGroupColumns };
